export function authenticatedMutation (state, val) {
    state.authenticated = val
}

export function departmentMutation (state, val) {
    state.department = val
}